// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8900cd8","732":"2cde4092","977":"fa00b29b"}[chunkId] + ".chunk.js";
};